// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'payroll.page.title': 'Payrolls',
    'payroll.page.search_results': 'Search Results',
    'payroll.page.create.title': 'Create New Payroll',
    'payroll.page.search.title': 'Find Payrolls',
    'payroll.page.report.title': 'Payroll Report',
    'payroll.page.payments.title': 'Payroll Payments',
    'payroll.page.title.import-p45': 'Import P45',
    'payroll.page.run.title': 'Run Payroll',
    'payroll.page.all': 'All',
    'payroll.title.pay_advise': 'Pay Advice',

    'payroll.button.cancel': 'Cancel',
    'payroll.button.select': 'Select',
    'payroll.button.find': 'Find Payrolls',
    'payroll.button.search': 'Apply',
    'payroll.button.payments': 'Record Payment',
    'payroll.button.new': 'New Payroll',
    'payroll.button.save': 'Save',
    'payroll.button.run': 'Run Payroll',
    'payroll.button.edit': 'Edit',
    'payroll.button.reset': 'Reset',
    'payroll.button.close': 'Close Payroll',
    'payroll.button.report': 'Report',
    'payroll.button.approve': 'Approve',
    'payroll.button.cancel_payroll': 'Cancel Payroll',
    'payroll.button.print': 'Print Payslips',
    'payroll.button.email': 'Email Payslips',
    'payroll.button.download': 'Download CSV',
    'payroll.button.register': 'Payroll Register',

    'payroll.button.roll_back': 'Rollback',

    'payroll.error.title': 'the following team members have missing information:',
    'payroll.error.no_basic_pay': 'No basic pay or hourly rate salary package found.',
    'payroll.error.salaried_with_hourly_time_sheet': 'Sorry you cant have an annual salary and be paid hourly. Did you mean to pay overtime?',

    'payroll.placeholder.search': 'Search payrolls',

    'payroll.message.no_payrolls': "It looks like you haven't created your first payroll.",
    'payroll.message.no_team': 'No team members found for this pay period',
    'payroll.message.first_payrolls': "It looks like your're running payroll for the first time. When does your payroll start?",

    'payroll.link.create_first_payroll': 'Click here to start',
    'payroll.link.create_team': 'Click here to create team members',
    'payroll.link.payrolls': ' Return to Payrolls',
    'payroll.link.retry': 'Click here to retry',

    'payroll.checkbox.all': 'Check All',
    'payroll.checkbox.actions_label': 'with selected',

    'payroll.label.date': 'Date',
    'payroll.label.batches': 'Batches',
    'payroll.label.employee': 'Employee',
    'payroll.label.payroll_type': 'Payroll Type',
    'payroll.label.pay_cycle': 'Pay Cycle',
    'payroll.label.balance': 'Balance',
    'payroll.label.tin': 'TIN',
    'payroll.label.trn': 'TRN',
    'payroll.label.nis': 'NIS',

    'payroll.label.from_date': 'From Date',
    'payroll.label.thru_date': 'thru Date',
    'payroll.label.transaction_date': 'Transaction Date',
    'payroll.label.payroll_start_date': 'Payroll Start Date',
    'payroll.label.payroll_description': 'Payroll Description',
    'payroll.label.negative_net_pay': 'An employee has negative net pay',

    'payroll.label.team_member': 'Team Member',
    'payroll.label.date_of_leaving': 'Date of Leaving',
    'payroll.label.gross_pay': 'Total Gross Pay to date (Less Redundancy Payment)',
    'payroll.label.redundancy_payment': 'Redundancy Payment',
    'payroll.label.perquisites': 'Perquisites',
    'payroll.label.threshold_utilized': 'Threshold utilized to date',
    'payroll.label.total_nis': 'Total NIS deducted to date',
    'payroll.label.total_nht': 'Total NHT deducted to date',
    'payroll.label.total_ed_tax': 'Total Ed Tax deducted to date',
    'payroll.label.total_paye': 'Total PAYE Tax deducted to date',
    'payroll.label.total_statutory_income': 'Total Statutory Income to date',
    'payroll.label.total_super_annuation': 'Total Superannuation deducted to date',
    'payroll.label.total_approved_expenses': 'Total Approved Expenses to date',
    'payroll.label.total_deductions': 'Total Deductions',
    'payroll.label.payment_frequency': 'Payment Frequency',
    'payroll.label.weeks_employed': 'Weeks Employed',
    'payroll.label.months_employed': 'Months Employed',

    'payroll.label.payroll_pay_period_name': 'Payroll Pay Period',
    'payroll.label.payroll_pay_period_cycle_name': 'Payroll Pay Period Cycle',

    'payroll.label.currency_name': 'Currency',
    'payroll.label.currency_balance_in_cents': 'Balance',
    'payroll.label.currency_total_in_cents': 'Total',
    'payroll.label.status': 'Status',

    'payroll.label.message': 'What period are you running the payroll for?',
    'payroll.label.payroll_period': 'Payroll Period',

    'payroll.message.pick_start_date': 'When does this pay period start? The date you pick becomes the start of the period.',

    'payroll.sort.field_label': 'Field',
    'payroll.sort.direction_label': 'Direction',
    'payroll.sort.direction_ascending': 'Ascending',
    'payroll.sort.direction_descending': 'Descending',

    'payroll.modal.title.payroll_delete_permanently': 'Delete Payroll',
    'payroll.modal.title.payroll_restore': 'Restore Payroll',
    'payroll.modal.title.payroll_close': 'Close Payroll',
    'payroll.modal.title.payroll_approve': 'Approve Payroll',
    'payroll.modal.title.payroll_cancel': 'Cancel Payroll',
    'payroll.modal.title.payroll_roll_back': 'Rollback Payroll',
    'payroll.modal.title.payroll_run': 'Run Payroll',
    'payroll.modal.title.cancel_adjustments': 'Cancel Created Adjustments',

    'payroll.modal.message.payroll_delete_permanently':
        'Are you sure that you want to permanently delete this payroll? This action cannot be undone. | Are you sure that you want to permanently delete these payrolls? This action cannot be undone.',
    'payroll.modal.message.payroll_restore': 'Are you sure that you want to restore this payroll? | Are you sure that you want to restore these payrolls?',
    'payroll.modal.message.payroll_close': 'Are you sure that you want to close this payroll?',
    'payroll.modal.message.payroll_approve': 'Journal Entry Date',
    'payroll.modal.message.payroll_cancel': 'Cancelling this payroll run will result in payslips being cancelled and bank transactions removed. Are you sure that you want to cancel this payroll?',
    'payroll.modal.message.payroll_roll_back': 'Are you sure that you want to rollback this payroll?',
    'payroll.modal.message.payroll_run': 'Are you sure that you want to run this payroll?',
    'payroll.modal.message.cancel_adjustments': 'Do you want to delete the adjustments that were created in this payroll batch?',

    'payroll.success.message.payroll_created': 'Please check your email for the payroll status',
    'payroll.success.message.payroll_payment_created': 'Your payments have been recorded',
    'payroll.success.message.payroll_closed': 'Payroll has been closed successfully',
    'payroll.success.message.payroll_approved': 'Payroll has been approved successfully',
    'payroll.success.message.payroll_voided': 'Payroll has been voided successfully',
    'payroll.success.message.payroll_rolled_back': 'Payroll has been rolled back successfully',
    'payroll.success.message.payroll_cancelled': 'Payroll has been cancelled successfully',

    'payroll.error.message.approved_only': 'You can only make payment for approved payrolls',
    'payroll.error.message.open_batch': 'Please close or approve any open any payroll batches before attempting to run another',
    'payroll.error.message.cant_close_open_batch': 'Please close or approve any open any payroll batches before attempting to close payroll',
    'payroll.error.message.already_selected': 'Payroll already ran for the period. Did you forget to close the payroll?',
    'payroll.error.message.no_period_available': 'There is no pay period available to run for this frequency.',
    'payroll.error.message.payroll_closed': 'this payroll was already closed',
    'payroll.error.message.payroll_approved': 'this payroll was already approved',
    'payroll.error.message.payroll_voided': 'this payroll was already voided',
    'payroll.error.message.payroll_rolled_back': 'this payroll was already rolled back',
    'payroll.error.message.error_loading_page': 'Sorry, there was an error loading payroll.| Sorry, there was an error loading payrolls.',
    'payroll.error.message.payroll_run_date': "Payroll can only be ran after the book's closing date",
    'payroll.error.message.payroll_register': 'Sorry, there was an error loading payroll register.',
    'payroll.error.message.payroll_cancelled': 'Sorry, there was an error cancelling payroll run',
    'payroll.error.message.conflict': 'This payroll cannot be run because it conflicts with a payroll that already exists. Please review the pay period and the team members being paid, then try again.',
    'payroll.error.message.approve_conflict': 'This payroll batch cannot be approved because of its current status. Review the batch, then cancel it first if it has to be approved again.',

    'payroll-report.label.description': 'Description',
    'payroll-report.label.total': 'Total',
    'payroll-report.label.employer': 'Employer',
    'payroll-report.label.employee': 'Employee',

    'payroll-payment.label.name': 'Name',
    'payroll-payment.label.bank': 'Bank',
    'payroll-payment.label.account': 'Account',
    'payroll-payment.label.amount_due': 'Amount Due',

    'payroll.success.message.email_payroll_batch': 'Payslips will be emailed shortly. You will receive an email notification once they have been sent.',
    'payroll.modal.title.email_payslips': 'Email Payslips',
    'payroll.modal.message.email_payslips_message': 'Are you sure you want to email payslips to all listed team members? Please press confirm to proceed',
    'payroll.button.confirm': 'Confirm',
};
